import api from "../api";

export const customFieldsService = {
  fetchCustomFields: async (accountId) => {
    const res = await api.get(`/api/custom-fields/?account_id=${accountId}`);
    return res.data;
  },

  createForAccount: async (payload) => {
    const res = await api.post(`/api/custom-fields/`, payload);
    return res.data;
  },

  updateField: async (id, payload) => {
    const res = await api.patch(`/api/custom-fields/${id}/`, payload);
    return res.data;
  },

  removeField: async (id) => {
    await api.delete(`/api/custom-fields/${id}/`);
  },

  fetchCustomFieldValues: async (clientId) => {
    const res = await api.get(`/api/leads/${clientId}/custom-fields/`);
    return res.data;
  },

  updateCustomFieldValue: async (clientId, id, newFieldValue) => {
    const res = await api.put(
      `/api/leads/${clientId}/custom-fields/${id}/`,
      newFieldValue,
    );
    return res.data;
  },

  createCustomFieldValue: async (clientId, fieldDataValue) => {
    const res = await api.post(
      `/api/leads/${clientId}/custom-fields/`,
      fieldDataValue,
    );
    return res.data;
  },

  getLeadCustomFieldValues: async ({ leadId }) => {
    const res = await api.get(`/api/leads/${leadId}/custom-fields/`);
    return res.data?.data ?? res.data;
  },

};
